import React, { useState } from "react";
import "./loader.css"
import logo from "../../assets/logoDark.png"

function Loader(props) {
    

    return(
        <div className="loader">
            <img src={logo} alt="" />
        </div>
    )
}

export default Loader